/**
 * Affiliate notification bar.
 *
 * Superfiliate's utm params are present only on the landing request, so the
 * code is captured once and replayed from sessionStorage on every later page.
 * Rendered by sections/affiliate-bar.liquid, which ships the bar hidden.
 */
(function () {
  const STORAGE_KEY = 'monatAffiliateCode';
  // utm_campaign is attacker-controlled and we persist it for the whole session,
  // so it is whitelisted before it can ever reach storage or the DOM.
  const CODE_PATTERN = /^[A-Z0-9_-]{1,64}$/;

  const bar = document.querySelector('affiliate-bar');
  if (!bar) return;

  // sessionStorage throws rather than no-ops in locked-down browser modes.
  const readCode = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  };

  const writeCode = (code) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (error) {
      /* storage unavailable; the bar simply stays hidden on later pages */
    }
  };

  const params = new URLSearchParams(window.location.search);
  if ((params.get('utm_source') || '').trim().toLowerCase() === 'superfiliate') {
    const landingCode = (params.get('utm_campaign') || '').trim().toUpperCase();
    // Always overwrite: following a second affiliate link mid-session should
    // switch the shopper to the new affiliate, not keep the first one.
    if (CODE_PATTERN.test(landingCode)) writeCode(landingCode);
  }

  const activeCode = readCode();
  if (!activeCode) return;

  let overrides = {};
  const overridesTag = bar.querySelector('[data-affiliate-overrides]');
  if (overridesTag) {
    try {
      overrides = JSON.parse(overridesTag.textContent) || {};
    } catch (error) {
      overrides = {};
    }
  }

  const deriveName = (code) =>
    code
      .split('-')
      .map((part) => part.trim().toLowerCase())
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');

  // hasOwnProperty, not a plain lookup: a code like CONSTRUCTOR would otherwise
  // resolve against Object.prototype.
  const override = Object.prototype.hasOwnProperty.call(overrides, activeCode)
    ? overrides[activeCode]
    : '';
  const name =
    typeof override === 'string' && override.trim() ? override.trim() : deriveName(activeCode);
  if (!name) return;

  const slot = bar.querySelector('[data-affiliate-name]');
  if (!slot) return;

  // textContent, never innerHTML: name can originate from the URL.
  slot.textContent = name;
  bar.removeAttribute('hidden');
})();
